import React, {Fragment} from 'react'
import Section from '../common/Section'
import styles from '../../styles/modules/common/features.module.scss'
import {isMobile, isTablet} from 'react-device-detect';
import {getStaticPath} from '../../utils';

interface  Props{
    title?: string,
    withSubtitle: boolean,
    features : {
        featureTitle: string,
        featureImage: string,
        featureText: string,
    }[]
    className?:string,
    itemClassName?:string,
    sectionClass?:string,
    isGreyBackground?:boolean,
    elementID?:string,
}


const getImage = (imageDict) => {
    if (typeof imageDict == 'object' ) {
        let image;
        if(isMobile) {
            image =  imageDict && imageDict['mobile'] ? imageDict['mobile'] : imageDict && imageDict['default']
        } else if (isTablet) {
            image =  imageDict && imageDict['tablet']? imageDict['tablet'] : imageDict && imageDict['default']
        } else {
            image =  imageDict && imageDict['desktop']? imageDict['desktop'] : imageDict && imageDict['default']
        }
        return getStaticPath(image)
    }
    return getStaticPath(imageDict); // image is string i.e path
}

class CultureTwoRowComponent extends React.PureComponent<Props> {
    render() {
        const props = this.props;
        return (
            <Fragment>
                <Section className={`${styles.banner_title} ${props.sectionClass} ${styles.culture__heading_mb}`} hasPadding={true} title={props.title ? props.title: ''} dataBg={props.isGreyBackground ? "shade-2":''} id={props.elementID ? props.elementID : ''}>
                        <div className={`container ${styles.samsung__tab}`}>
                            <p className={`${styles.main_subltitle} ${styles.career_text}`}>Our teams are bold, innovative, dynamic and working with them constantly raises one’s own game. We have figured that the best way to get results is by making the workplace a fun place to be at for Onsitegoer’s. We love to chase big goals each quarter and have fun while we are at it. In fact, we are constantly working on evolving our culture. If you love a dynamic work culture, are outcome-oriented, and are obsessed with customers as much as we are, you belong here!</p>
                            <div className={`row ${styles.feature_list} ${props.className? props.className: ''}` }>
                               { props.features && props.features.map((feature, index)=>{
                                  return (
                                    <Fragment key={`key-two-row-${index}`}>
                                        <div className={`col-12 col-sm-6 col-md-6 col-lg-4 ${styles.feature_item} ${styles.feature_item__double_row}  ${props.itemClassName? props.itemClassName: ''}` } >
                                            <div
                                                className={`${styles.feature_item__image} ${styles.culture_item_image__double_row}`}
                                                style={{ 'backgroundImage': `url(${getImage(feature.featureImage)}` }}
                                            ></div>
                                            <div className={feature.featureTitle  ? ` ${styles.feature_item__text} ${styles.item_text__double_row} ${styles.feature_item__subtext} ${styles.no_margin_double_row} ${styles.culture__double_row}` : ` ${styles.feature_item__text}`}>
                                                 {feature.featureTitle  &&
                                                    <div className={`${styles.feature_item__title} ${styles.culture__double_row}`}>
                                                        <p className="level-one">{feature.featureTitle}</p>
                                                    </div>}
                                                <p className={feature.featureTitle  ? `${styles.feature_desc} level-two` : `${styles.feature_desc} level-one` }>{feature.featureText}</p>
                                            </div>
                                        </div>
                                    </Fragment>
                                )})
                              }
                            </div>
                        </div>
                </Section>
            </Fragment>
        )
    }

}

export default CultureTwoRowComponent;
